/**
 * The Ask AI opening lines, per surface.
 *
 * `dashboard` — the widget on the New tab. The dashboard around it answers
 * *what* moved; it cannot answer *why*, because the why is in the
 * observations. That division is the point of the widget, so it is what the
 * copy says. Not a greeting: a name in a headline tells the reader nothing
 * about what the panel is for.
 *
 * `chat` — the empty Ask AI page, which has nothing around it to divide
 * labour with, so it opens the way a chat does. `{name}` is replaced with
 * the reader's first name, and `title` is used when there isn't one.
 *
 * Override contract: `prioritiesCopy.askAI.<surface>.{title,titleWithName,subtitle}`.
 */
const ASK_AI_COPY = {
  dashboard: {
    title: "The dashboard shows what moved. Ask why.",
    subtitle: "Start with a question below, or write your own — answered from the observations behind these numbers.",
  },
  chat: {
    title: "What would you like to know?",
    titleWithName: "Hi {name}, what would you like to know?",
    subtitle: "Pick a question about a topic your customers raise, or ask your own below.",
  },
};

export const resolveAskAICopy = (copy, surface = "dashboard") => ({
  ...ASK_AI_COPY[surface],
  ...(copy?.askAI?.[surface] || {}),
});
